import React, { useEffect, useState } from 'react'
import './index.scss'

import { Button, Swiper, CenterPopup, Toast } from 'antd-mobile'
import { MailOutline } from 'antd-mobile-icons'
import { updateUserEmailApi } from '../../api/yearEndReportApi'

let EMailModal = ({ visible, setVisible, send, okText = "确认" }) => {
  // let [visible, setVisible] = useState(false);
  // useEffect(() => {
  //   setVisible(props.visible);
  // }, [props.visible]);
  let [loading, setLoading] = useState(false)

  let emailRef = React.createRef()
  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') ?? '{}')
  let emailDefault = userInfo?.email ?? ''
  let openId = userInfo.openId

  let validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return regex.test(email)
  }
  let sendHandle = async () => {
    let email = emailRef.current.value

    try {
      setLoading(true)
      if (!validateEmail(email)) {
        Toast.show({
          content: '请输入正确的email',
        })
      }

      let params = {
        openId: userInfo.openId,
        email,
      }
      await updateUserEmailApi(params)

      userInfo.email = email

      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))

      await send(email)

      // localStorage.setItem('email', email)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }
  return (
    <CenterPopup visible={visible}>
      <div className="emailWrap">
        <div className="emailHead">请输入邮箱地址，用于接受报告</div>
        <div className="formWrap">
          <div className="emailIcon">
            <MailOutline fontSize={22} />
          </div>
          <input type="text" ref={emailRef} defaultValue={emailDefault} placeholder="请输入邮箱" />

        </div>
        <div className="tipInfo">
          <h6>温馨提示</h6>
          <p>为确保您能正常接收我们的报告，请准确填写邮箱地址。 错误的邮箱可能导致无法收到报告或邮件被退件。 请您仔细核对并确保邮箱服务正常。</p>
        </div>
        <div className="foot">
          <Button
            className="btn"
            color="primary"
            fill="outline"
            onClick={() => {
              setVisible(false)
            }}
          >
            取消
          </Button>
          <Button className="btn" color="primary" loading={loading} onClick={sendHandle}>
            {okText}
          </Button>
        </div>
      </div>
    </CenterPopup>
  )
}

export default EMailModal
